import { FileProps } from '../utils/files';
import API from './api';
import { Building, Location } from './buildings';

const BASE_URL = '2019-02-19';

export interface Unit {
  id: number;
  bedrooms: number | string;
  bathrooms: number | string;
  unit_number: string;
  move_in: Date;
  lease_duration: any;
  building_id: number;
  addresses?: Location[];
  primary_address: Location;
  images: FileProps[];
  market_rent: number;
  square_footage: number;
  building: Pick<
    Building,
    | 'amenities'
    | 'description'
    | 'name'
    | 'neighborhood_description'
    | 'neighborhood_image'
    | 'neighborhood_name'
    | 'type'
    | 'building_group_id'
  >;
}

export interface GetUnitParams {
  building_id?: number;
  location?: string;
  limit?: number;
  offset?: number;
  min_price?: string;
  max_price?: string;
  bedrooms?: string;
  bathrooms?: string;
  square_feet?: string;
  sort_by?: string;
}

export interface BookTourPayload {
  form: {
    email: string;
    first_name: string;
    last_name: string;
    notes: string;
    phone: string;
  };
}

export const getUnit = async (id: number): Promise<Unit> =>
  API.get(`${BASE_URL}/leasing/units/${id}`).then(mapUnit);

export const getUnits = async (params: GetUnitParams): Promise<Unit[]> => {
  const urlParams = new URLSearchParams();
  Object.entries(params).forEach(
    ([key, value]) => value && urlParams.set(key, value)
  );
  return API.get(`${API.BASE_URL}/leasing/units/?${urlParams}`);
};

export const requestTour = async (unitId: number, payload: BookTourPayload) =>
  API.post(`${BASE_URL}/leasing/units/${unitId}/tours`, {
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  });

const mapUnit = (unit: any): Unit => ({
  ...unit,
  photos: [],
  price: Math.random() * 2000 + 100,
});
